var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-0",attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.tenants),function(tenant,index){return _c('v-flex',{key:index,staticClass:"d-flex flex-column",attrs:{"xs12":"","md3":""}},[_c('ReservationTenantCard',{attrs:{"tenant":tenant}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }